import QuestionTopicTags from './questionTopicTags'

export { QuestionTopicTags }
